import React, { useState } from 'react';
import { ChevronDownIcon, KeyIcon, UserCircle } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
type MenuItem = {
  label: string;
  submenu?: {
    label: string;
    path: string;
  }[];
};
const menuItems: MenuItem[] = [{
  label: 'Dashboard',
  submenu: [{
    label: 'Scouting',
    path: '/dashboard/scouting'
  }, {
    label: 'Platform',
    path: '/dashboard/platform'
  }]
}, {
  label: 'Players',
  submenu: [{
    label: 'All',
    path: '/players/all'
  }, {
    label: 'My Favourite',
    path: '/players/favorites'
  }, {
    label: 'My Searches',
    path: '/players/searches'
  }]
}, {
  label: 'Teams',
  submenu: [{
    label: 'All',
    path: '/teams/all'
  }, {
    label: 'My Team',
    path: '/teams/my-team'
  }, {
    label: 'My Favourite',
    path: '/teams/favorites'
  }]
}, {
  label: 'Matches',
  submenu: [{
    label: 'Table',
    path: '/matches/table'
  }, {
    label: 'Calendar',
    path: '/matches/calendar'
  }]
}, {
  label: 'Reports',
  submenu: [{
    label: 'TBD',
    path: '/reports'
  }]
}];
const Navigation = () => {
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);
  const location = useLocation();
  const isActiveRoute = (item: MenuItem) => {
    return item.submenu?.some(subItem => location.pathname.startsWith(subItem.path));
  };
  return <div className="bg-white shadow-md" data-id="element-9" data-mp="158yhjupqahnb">
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-between" data-id="element-10" data-mp="1a6hu8q6s2md5">
        <div className="flex items-center space-x-2 w-48" data-id="element-11" data-mp="1f51fsphglw4z">
          <span className="font-bold text-lg" data-id="element-12" data-mp="1f6w50fzrkaev">LOGO</span>
        </div>
        <div className="flex justify-center" data-id="element-13" data-mp="1k57egpm5ciwk">
          {menuItems.map(item => <div key={item.label} className="relative" onMouseEnter={() => setHoveredItem(item.label)} onMouseLeave={() => setHoveredItem(null)} data-id="element-14" data-mp="ufh19tmed3gp">
              <button className={`px-4 py-3 flex items-center space-x-1 text-sm font-medium transition-colors
                  ${isActiveRoute(item) ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-700 hover:text-blue-600'}`} data-id="element-15" data-mp="146v8knklb7ke">
                <span data-id="element-16" data-mp="187nilj1adghq">{item.label}</span>
                {item.submenu && item.submenu.length > 0 && <ChevronDownIcon className="w-4 h-4" data-id="element-17" data-mp="1n57kgh2vyvjo" />}
              </button>
            </div>)}
        </div>
        <div className="flex items-center space-x-3 w-48 justify-end" data-id="element-18" data-mp="1i64e8tb66ja4">
          <span className="text-sm font-medium text-gray-700" data-id="element-19" data-mp="3ov99i7y4w589">Nome Utente</span>
          <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center" data-id="element-20" data-mp="3jx7rlqcg2byd">
            <UserCircle className="w-6 h-6 text-gray-600" data-id="element-21" data-mp="1zf5lbpn2nr7v" />
          </div>
        </div>
      </div>
      {/* Secondary Navigation */}
      <div className="bg-gray-200" data-id="element-22" data-mp="24cyr4hkgqj7m">
        <div className="max-w-7xl mx-auto px-4" data-id="element-23" data-mp="24g30rugp675o">
          <div className="flex space-x-6 py-2" data-id="element-24" data-mp="1ppvro5cky0hn">
            <Link to="/players/all" className="text-sm text-gray-700 hover:text-blue-600 transition-colors" data-id="element-25" data-mp="1pmztcfwtl9so">
              All
            </Link>
            <Link to="/players/favorites" className="text-sm text-gray-700 hover:text-blue-600 transition-colors" data-id="element-26" data-mp="1gn4dhxsbkqmb">
              My Favourite
            </Link>
            <Link to="/players/searches" className="text-sm text-gray-700 hover:text-blue-600 transition-colors" data-id="element-27" data-mp="16s2nkzq7zkio">
              My Searches
            </Link>
            <Link to="/players/suggestion" className="text-sm text-gray-700 hover:text-blue-600 transition-colors" data-id="element-28" data-mp="3152919ha78xv">
              Suggestion
            </Link>
          </div>
        </div>
      </div>
      {hoveredItem && menuItems.find(item => item.label === hoveredItem)?.submenu && <div className="absolute w-full bg-white border-t border-gray-100 shadow-sm" onMouseEnter={() => setHoveredItem(hoveredItem)} onMouseLeave={() => setHoveredItem(null)} data-id="element-29" data-mp="x0677kxodlhq">
            <div className="max-w-7xl mx-auto px-4 py-2" data-id="element-30" data-mp="n3a2zret7liz">
              <div className="flex space-x-6" data-id="element-31" data-mp="ibid7j3h9jtw">
                {menuItems.find(item => item.label === hoveredItem)?.submenu?.map(subItem => <Link key={subItem.path} to={subItem.path} className="text-sm text-gray-700 hover:text-blue-600 transition-colors" data-id="element-32" data-mp="da2o9fy6it68">
                      {subItem.label}
                    </Link>)}
              </div>
            </div>
          </div>}
    </div>;
};
export default Navigation;